import { useIntl } from 'react-intl';

import { useLocation } from '@/utils/location-provider';

import {
	ProductPriceCardProps,
	FreePriceCard,
	StandardPriceCard,
	PremiumPriceCard,
	EnterprisePriceCard,
} from './pricing-calculator-plan-card.tsx';

const SERVICE_COLLECTION_PRICING_PATH = '/collections/service/pricing';
const JSM_BUNDLE = 'jira-service-management';

const useShouldPropagateJsmIntent = () => {
	const location = useLocation();
	const isServiceCollectionPricingPage = location.pathname
		.replace(/\/$/, '')
		.endsWith(SERVICE_COLLECTION_PRICING_PATH);

	const hasExplicitJsmIntent =
		isServiceCollectionPricingPage &&
		new URLSearchParams(location.search).get('bundle') === JSM_BUNDLE;

	return hasExplicitJsmIntent;
};

export const ServiceCollectionFreePriceCard = (props: ProductPriceCardProps) => {
	const intl = useIntl();
	const shouldPropagateJsmIntent = useShouldPropagateJsmIntent();
	return (
		<FreePriceCard
			{...props}
			shouldPropagateJsmIntent={shouldPropagateJsmIntent}
			tierLabelType="agent"
			monthlyPerUserLabel={intl.formatMessage({
				id: 'ServiceCollectionPriceCard.perAgentPerMonth',
				defaultMessage: 'per agent / month',
			})}
		/>
	);
};

export const ServiceCollectionStandardPriceCard = (props: ProductPriceCardProps) => {
	const intl = useIntl();
	const shouldPropagateJsmIntent = useShouldPropagateJsmIntent();
	return (
		<StandardPriceCard
			{...props}
			shouldPropagateJsmIntent={shouldPropagateJsmIntent}
			tierLabelType="agent"
			monthlyPerUserLabel={intl.formatMessage({
				id: 'ServiceCollectionPriceCard.perAgentPerMonth',
				defaultMessage: 'per agent / month',
			})}
		/>
	);
};

export const ServiceCollectionPremiumPriceCard = (props: ProductPriceCardProps) => {
	const intl = useIntl();
	const shouldPropagateJsmIntent = useShouldPropagateJsmIntent();
	return (
		<PremiumPriceCard
			{...props}
			shouldPropagateJsmIntent={shouldPropagateJsmIntent}
			tierLabelType="agent"
			monthlyPerUserLabel={intl.formatMessage({
				id: 'ServiceCollectionPriceCard.perAgentPerMonth',
				defaultMessage: 'per agent / month',
			})}
		/>
	);
};

export const ServiceCollectionEnterprisePriceCard = (props: ProductPriceCardProps) => {
	const intl = useIntl();
	return (
		<EnterprisePriceCard
			{...props}
			tierLabelType="agent"
			monthlyPerUserLabel={intl.formatMessage({
				id: 'ServiceCollectionPriceCard.perAgentPerMonth',
				defaultMessage: 'per agent / month',
			})}
		/>
	);
};
